// extracted by mini-css-extract-plugin
module.exports = {"content":"graficaarc_content__mpBve","grafic":"graficaarc_grafic__zF4fS"};